import "./App.css";
import Home from "./components/Home";

export default function App() {
  return (
    <div className="bg-[#EEE8DF] ">
      <Home/>

    </div>
  );
}
